<h2 class="text-xl font-semibold mt-2 mb-1">{{ '#WWS_BASISARTIKELSTAND.DIALOGE.ARTIKEL_HINZUFUEGEN.TITEL' | translate }}</h2>
<div class="flex flex-col w-full">
  <label class="mb-2">{{ '#WWS_BASISARTIKELSTAND.DIALOGE.ARTIKEL_HINZUFUEGEN.SUB_TITEL' | translate }}</label>
  <div class="overflow-auto max-h-[40vh] mt-2 mb-3">
    @for (basisartikel of artikelWithSelection$ | async; track basisartikel; let i = $index; let last = $last) {
      <div
        class="flex flex-col gap-1 py-2 cursor-pointer select-none" (click)="selectArtikel(basisartikel.basisartikel)"
        [ngClass]="{'!bg-secondary-200': basisartikel.selected, 'border-b border-solid': !last }">
        <div>
          <span class="text-base font-semibold">{{ basisartikel.basisartikel.artikel.artkurzbez }}</span>
        </div>
        <div>
          <span class="text-sm text-gray-500">{{ basisartikel.basisartikel.artikel.nummer }}</span>
        </div>
      </div>
    }
  </div>
</div>

<div class="flex flex-row w-full gap-2">
  <button class="soft-button secondary w-1/2 mt-2 h-14" (click)="close([])">{{ '#WWS_BASISARTIKELSTAND.DIALOGE.SCHLIESSEN' | translate }}</button>
  <button class="soft-button primary w-1/2 mt-2 h-14" (click)="saveArtikel()">{{ '#WWS_BASISARTIKELSTAND.DIALOGE.HINZUFUEGEN' | translate }}</button>
</div>
